<template>
    <div class="join-apply">
         <div class="section-content">
                 <article>
                     <div class="content">
                         <div class="title">意向调查须知</div>
                         <div>本意向调查表仅供我公司对有意向成为七田真中心合伙人（以下简称“意向合伙人”）基本资料的初步了解，请意向合伙人认真阅读意向调查须知并如实填写意向调查表。意向合伙人从我司、关联公司或我司任何雇员，代理商处 得到的所有信息都是高度机密的（“机密信息”），意向合伙人应予以严格保密。</div>
                         <div>如未取得我司书面同意，意向合伙人在任何时候均不得向任何个人、单位、公司或其它实体泄漏，公布或透漏任何机密信息，也不得直接或间接利用机密信息为我自己或合作人以外的其它任何个人、单位、公司或其它实体谋取利益。</div>
                         <div>意向合伙人同意，我司对意向合伙人提供的信息资料进行审查，并根据实际情况要约意向合伙人面试，合作经营权的授予最终由我司决定。</div>
                         <div>
                             <div class="confirm">
                                 <label>
                                     <input type="checkbox"   checked/>
                                     我已阅读，理解并赞同上述所有内容
                                     <div class="show-box" ></div>
                                 </label>
                             </div>
                             <div class="btn next" @click="routeFn">确认,下一步 </div>
                         </div>

                     </div>

                 </article>

         </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{

            }
        },
        methods:{
            routeFn(){
                this.$router.push('/join-info');
            }
        }
    }
    // (function(){
    //
    //     var inp=document.querySelector("input[type='checkbox']");
    //     var btn=document.querySelector(".next");
    //
    //     inp.onchange= function(){
    //         console.log(inp.checked); //判断是否选中
    //         if(inp.checked==true){
    //             btn.classList.remove("active");
    //             btn.href="{:U('Index/info')}";
    //         }else{
    //             btn.classList.add("active");
    //             btn.removeAttribute("href");
    //             //    return;
    //         }
    //         btn.onclick=function(){
    //             console.log(inp.checked);
    //         }
    //     }
    //
    // })

</script>
<style lang="less" scoped>
    .join-apply{
        article{
            margin:50px auto;

            width:1040px;
            background-color:#F6F6F6;
            font-size:20px;
            font-family:PingFangSC-Regular;
            color:#3B3B3B;
        }
        .content{
            width:1040px;
            background-color: #ffffff;
            border-radius: 4px;
            padding-bottom: 60px;

        }
        .content>div{
            margin: 0px 40px 56px 66px;
            line-height: 40px;
            font-weight:400;

        }
        .content .title{
            color:#323335;
            font-size: 28px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            height: 80px;
            line-height:100px;
            text-align: center;
        }
        .confirm{
            color:#5A5E66;
            font-size:14px;
            text-align: center;
            margin-top: 40px;

        }

        .next{
            display: block;
            margin:20px auto;
            width:200px;
            height:40px;
            line-height: 40px;
            text-align: center;
            background-color: #FFCC01;
            color:#ffffff;
            font-size:16px;
            font-family:PingFangSC-Medium;
            cursor: pointer;
            text-decoration: none;
        }
        .next:hover{
            color:#ffffff;
        }

        label {
            position: relative;
            cursor: pointer;
        }
        label input {
            cursor: pointer;
        }

        input:checked + .show-box {
            background: #FFCC01;
            border: 0px solid #d8d8d8;
        }

        .show-box {
            position: absolute;
            top: 0;
            left: 0;
            width: 16px;
            height: 16px;
            border-radius: 2px;
            border: 1px solid #d8d8d8;
            background: white;
        }
        .show-box:before {
            content: '';
            position: absolute;
            top: 2px;
            left: 6px;
            width: 3px;
            height: 8px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
        }
        .active{
            color: #323335;
            background-color: #cccccc;
            opacity: 0.7;
            cursor: not-allowed;
      }

    }
</style>
